export const REGION_IMAGES = {
  "chandigarh-tricity":
    "https://images.unsplash.com/photo-1674883042269-17097655cfca?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  ahmedabad:
    "https://images.unsplash.com/photo-1713260443292-ec016608ca42?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "delhi-ncr":
    "https://images.unsplash.com/photo-1587474260584-136574528ed5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const DEFAULT_REGION_IMAGE =
  "https://images.unsplash.com/photo-1519501025264-65ba15a82390?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const regionImage = (slug) => REGION_IMAGES[slug] || DEFAULT_REGION_IMAGE;

export const ownerDisplayName = (c) => c.owner_name || "Region owner to be announced";

export const ownerPhotoSrc = (url) =>
  url && url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
